const SAFE_ERRORS: Record<string, string> = {
  authentication_invalid_token: 'Your session has expired. Sign in again.',
  authentication_required: 'Sign in to continue.',
  authorization_denied: 'You do not have access to this item.',
  authorization_insufficient_scope: 'You do not have permission to perform this action.',
  billing_insufficient_credits: 'You need more credits to continue.',
  billing_unavailable: 'Billing is temporarily unavailable. Try again shortly.',
  rate_limit_exceeded: 'Please wait a moment and try again.',
  realtime_feed_capacity_reached: 'Stop a feed before starting another.',
};

/** Show known product errors without exposing provider messages, URLs or logs. */
export const getRealtimeErrorMessage = (error: unknown, fallback = 'Unable to complete this action. Try again.') => {
  const candidate = error as { response?: { data?: { error?: { code?: string } } }; error_code?: string; code?: string } | null;
  const code = candidate?.response?.data?.error?.code || candidate?.error_code || candidate?.code;
  return (code && SAFE_ERRORS[code]) || fallback;
};
